import { NgModule } from "@angular/core";
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import {
  AppLoaderInterceptor,
  CacheInterceptor,
  ErrorsModule,
  MaterialModule,
  OAuthInterceptor,
  CommonModule,
  ConvertParamsToUrlInterceptor,
  OAuthService,
} from "common";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { PartnerCoreModule } from "./core/core.module";
import { BrokerModule } from "./broker/broker.module";
import { UserModule } from "./user/user.module";
import { MatChipsModule } from "@angular/material/chips";
import { MatListModule } from "@angular/material/list";
import { ProfileModule } from "./profile/profile.module";
import { UpdatePasswordModule } from "./update-password/update-password.module";
import { SubmissionsModule } from "./feature-modules/submissions/submissions.module";
import { UsersModule } from "./feature-modules/users/users.module";
import { DashboardModule } from "./feature-modules/dashboard/dashboard.module";
import { AccountModule } from "./feature-modules/account/account.module";
import { AboutPageModule } from "./about/about-page.module";
import { AdminModule } from "./feature-modules/admin/admin.module";
import { SalesforceUidModule } from "./feature-modules/salesforce-uid/salesforce-uid.module";
import { OAuthService as PartnerOAuthService } from "@partner/core/services/oauth.service";
import { RefreshTokenInterceptor } from "@partner/core/interceptors/refresh-token.interceptor";

@NgModule({
  declarations: [AppComponent],
  imports: [
    AppRoutingModule,
    AboutPageModule,
    BrokerModule,
    CommonModule,
    PartnerCoreModule,
    UserModule,
    DashboardModule,
    UsersModule,
    ProfileModule,
    MaterialModule,
    MatChipsModule,
    MatListModule,
    UpdatePasswordModule,
    SubmissionsModule,
    AccountModule,
    AdminModule,
    SalesforceUidModule,
    ErrorsModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RefreshTokenInterceptor,
      multi: true,
    },
    { provide: HTTP_INTERCEPTORS, useClass: OAuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: AppLoaderInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: CacheInterceptor, multi: true },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ConvertParamsToUrlInterceptor,
      multi: true,
    },
    {
      provide: OAuthService,
      useClass: PartnerOAuthService,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
